import { APIClient } from '@/services'
import { alert } from '@codeleap/modals'
import { Profile } from '@/types'
import { t } from '@lingui/core/macro'

export const handleDeleteAccount = (id: Profile['id']) => {
  alert.ask({
    title: t`Delete Account`,
    body: t`Are you sure you want to delete your account? This will permanently erase your account`,
    options: [
      {
        text: t`Remove`,
        onPress: () => onFinalDeleteAccount(id),
        style: 'destructive'
      },
      {
        text: t`Cancel`,
        style: 'outline',
      },
    ]
  })
}

export const deleteAccount = async (id: Profile['id']) => {
  await APIClient.Session.logout()
  await APIClient.Session.deleteProfile(id)
}

const onFinalDeleteAccount = (id: Profile['id']) => {
  alert.ask({
    title: t`Confirm Deletion`,
    body: t`Your account will be deleted immediately. You cannot undo this action. Are you sure you want to proceed?`,
    options: [
      {
        text: t`Delete`,
        onPress: () => deleteAccount(id),
        style: 'destructive'
      },
      {
        text: t`Cancel`,
        style: 'outline',
      },
    ]
  })
}